// Dulcet Home — scripts propios (prefijo mt-)

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = target % 1 === 0 ? Math.round(value) : value.toFixed(1);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target % 1 === 0 ? target : target.toFixed(1);
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;

  var listaMinis = Array.prototype.slice.call(minis);
  var indiceActual = 0;

  function activar(indice) {
    if (indice < 0 || indice >= listaMinis.length) return;
    var mini = listaMinis[indice];
    var src = mini.getAttribute('data-full');
    var alt = mini.getAttribute('data-alt') || '';
    if (!src) return;
    principal.src = src;
    principal.alt = alt;
    listaMinis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
    mini.classList.add('mt-mini-activa');
    indiceActual = indice;
    if (mini.scrollIntoView) {
      mini.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  listaMinis.forEach(function (mini, indice) {
    mini.addEventListener('click', function () {
      activar(indice);
    });
  });

  // Deslizar con el dedo directamente sobre la foto principal (sin tener que
  // tocar las miniaturas) para pasar a la siguiente/anterior foto.
  if (listaMinis.length > 1) {
    var imagenWrap = principal.closest('.mt-prod-imagen-wrap') || principal.parentElement;
    var inicioX = null;
    var idPuntero = null;

    imagenWrap.addEventListener('pointerdown', function (e) {
      inicioX = e.clientX;
      idPuntero = e.pointerId;
    });

    imagenWrap.addEventListener('pointerup', function (e) {
      if (inicioX === null || e.pointerId !== idPuntero) return;
      var delta = e.clientX - inicioX;
      inicioX = null;
      var umbral = 40;
      if (delta <= -umbral) {
        activar(indiceActual + 1);
      } else if (delta >= umbral) {
        activar(indiceActual - 1);
      }
    });

    imagenWrap.addEventListener('pointercancel', function () {
      inicioX = null;
    });
  }
}

function mtInitVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var selects = form.querySelectorAll('[data-mt-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-compare]');
  var btn = form.querySelector('[data-mt-add-btn]');

  function moneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    });
  }

  function actualizar() {
    if (!selects.length) return;
    var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = moneda(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = moneda(variante.compare_at_price);
        precioCompareEl.hidden = false;
      } else {
        precioCompareEl.hidden = true;
      }
    }
    if (btn) {
      if (variante.available) {
        btn.disabled = false;
        btn.setAttribute('data-estado', 'disponible');
      } else {
        btn.disabled = true;
        btn.setAttribute('data-estado', 'agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}

function mtInitComparador() {
  var comparadores = document.querySelectorAll('[data-mt-comparador]');
  comparadores.forEach(function (wrap) {
    var range = wrap.querySelector('[data-mt-comparador-range]');
    if (!range) return;

    function fijarPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      wrap.style.setProperty('--mt-pos', pct + '%');
      range.value = pct;
    }

    function posDesdePuntero(e) {
      var rect = wrap.getBoundingClientRect();
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    // El input nativo sigue existiendo (oculto) solo para teclado/accesibilidad.
    range.addEventListener('input', function () {
      fijarPos(Number(range.value));
    });

    // El arrastre real (ratón y dedo) se maneja aquí con eventos de puntero,
    // en vez del "truco" del thumb invisible al 100%, que en algunos
    // navegadores se quedaba bloqueado tras el primer clic/toque.
    var arrastrando = false;

    wrap.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      if (wrap.setPointerCapture) {
        try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      }
      fijarPos(posDesdePuntero(e));
    });

    wrap.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      fijarPos(posDesdePuntero(e));
    });

    function soltar(e) {
      arrastrando = false;
      if (wrap.hasPointerCapture && wrap.releasePointerCapture && e && e.pointerId != null && wrap.hasPointerCapture(e.pointerId)) {
        wrap.releasePointerCapture(e.pointerId);
      }
    }
    wrap.addEventListener('pointerup', soltar);
    wrap.addEventListener('pointercancel', soltar);

    fijarPos(50);
  });
}

function mtInitCarruseles() {
  var wraps = document.querySelectorAll('[data-mt-carrusel]');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('[data-mt-carrusel-track]');
    var prev = wrap.querySelector('[data-mt-carrusel-prev]');
    var next = wrap.querySelector('[data-mt-carrusel-next]');
    if (!track || !prev || !next) return;

    function paso() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
      return (item.getBoundingClientRect().width + gap) * 2;
    }

    // El propio navegador anima el desplazamiento (CSS scroll-behavior: smooth
    // en la pista); no dependemos de requestAnimationFrame para que funcione
    // incluso si la pestaña está en segundo plano.
    prev.addEventListener('click', function () {
      var maxScroll = track.scrollWidth - track.clientWidth;
      track.scrollLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft - paso()));
    });
    next.addEventListener('click', function () {
      var maxScroll = track.scrollWidth - track.clientWidth;
      track.scrollLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft + paso()));
    });
  });
}

function mtInitFaq() {
  var botones = document.querySelectorAll('[data-mt-faq-boton]');
  if (!botones.length) return;
  botones.forEach(function (boton) {
    var respuesta = document.getElementById(boton.getAttribute('aria-controls'));
    if (!respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = boton.getAttribute('aria-expanded') === 'true';
      if (abierto) {
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        requestAnimationFrame(function () {
          respuesta.style.maxHeight = '0px';
        });
        boton.setAttribute('aria-expanded', 'false');
        boton.closest('[data-mt-faq-item]').classList.remove('mt-faq-abierta');
      } else {
        respuesta.hidden = false;
        respuesta.style.maxHeight = '0px';
        requestAnimationFrame(function () {
          respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
        });
        boton.setAttribute('aria-expanded', 'true');
        boton.closest('[data-mt-faq-item]').classList.add('mt-faq-abierta');
      }
    });
    respuesta.addEventListener('transitionend', function () {
      if (boton.getAttribute('aria-expanded') !== 'true') {
        respuesta.hidden = true;
      }
    });
  });
}

function mtInitTodo() {
  mtInitReveal();
  mtInitContadores();
  mtInitGaleriaProducto();
  mtInitVariantes();
  mtInitComparador();
  mtInitCarruseles();
  mtInitFaq();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mtInitTodo);
} else {
  mtInitTodo();
}
